// @flow
import React from 'react';
import moment from 'moment';
import i18n from 'i18n-js';
import { FormattedMessage } from 'react-intl';
import styles from './changeStopCardSubtitle.css';

type ChangeStopCardSubtitlePropTypes = {
  requestedByFirstName: string,
  requestedByLastName: string,
  requestedAt: string,
  start: string,
  end: string,
  date: string
};

const ChangeStopCardSubtitle = ({
  requestedByFirstName,
  requestedByLastName,
  requestedAt,
  start,
  end,
}: ChangeStopCardSubtitlePropTypes) => (
  <div className={styles.changeStopCardSubtitle}>
    <span>
      {`${i18n.t('changeStopRequests.requestForDates')} `}
        <strong className={styles.nameText}>{start}</strong>
      {` ${i18n.t('changeStopRequests.to.other')} `}
        <strong className={styles.nameText}>{end}</strong>
      {` ${i18n.t('changeStopRequests.by')} `}
        <strong className={styles.nameText}>
          { `${requestedByFirstName} ${requestedByLastName}` }
        </strong>
      { ` ${i18n.t('changeStopRequests.at')} ` }
        <strong className={styles.nameText}>
          {` ${requestedAt}`}
        </strong>
    </span>
  </div>
);
export default ChangeStopCardSubtitle;



// WEBPACK FOOTER //
// ./src/scripts/components/ChangeStopRequestCard/ChangeStopCardSubtitle/index.jsx